import {
  HttpBackend,
  provideHttpClient,
  withInterceptorsFromDi,
}                           from '@angular/common/http';
import { NgModule }         from '@angular/core';
import { LocalHttpBackend } from '~app/http/local/http-backend';
import { environment }      from '~environment';

@NgModule({
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    !environment.production && !environment.api ? { provide: HttpBackend, useClass: LocalHttpBackend } : [],
  ],
})
export class HttpModule {
}
